import React, { useContext } from 'react';
import { IconProps } from '../iconProps';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';

export default function IconPSD({
  isAutoscallable = true,
  sizeKey = '22x22',
  onClick,
  style,
}: IconProps) {
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      viewBox="0 0 23 22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3685_63598)">
        <path
          d="M22.4915 0.0302734H0.552734V21.9692H22.4915V0.0302734Z"
          fill="#4FC7EC"
        />
        <path
          d="M21.5258 0.996094H1.51758V21.0043H21.5258V0.996094Z"
          fill="#242238"
        />
        <path
          d="M5.88871 5.32996C5.88871 5.25433 5.90169 5.2243 5.96653 5.2243C6.45981 5.20909 7.43366 5.19409 8.42026 5.19409C10.9647 5.19409 11.9352 6.67454 11.9482 8.42556C11.9482 10.8253 10.1597 11.7352 8.25144 11.7352C7.88797 11.7352 7.53747 11.7352 7.44646 11.7352V15.1639C7.44646 15.2545 7.42064 15.2847 7.35562 15.2847H5.97951C5.91467 15.2847 5.88867 15.2545 5.88867 15.1791L5.88871 5.32996ZM7.4465 10.2712C7.55049 10.2862 7.74514 10.3012 8.2905 10.3012C9.3159 10.3012 10.3026 10.009 10.3026 8.49959C10.3026 7.29208 9.64057 6.67187 8.4203 6.67187C7.914 6.67187 7.55049 6.68691 7.4465 6.70212V10.2712Z"
          fill="#4FC7EC"
        />
        <path
          d="M15.1892 9.14241C14.5641 9.14241 14.3984 9.53338 14.3984 9.82016C14.3984 10.1825 14.5641 10.3786 15.5209 10.8315C16.8347 11.4654 17.396 12.024 17.396 13.1106C17.396 14.62 16.4138 15.4788 15.0105 15.4788C14.3345 15.4788 13.4815 15.4143 12.9457 15.022C12.8947 14.9917 12.8691 14.9465 12.8691 14.8709V13.4823C12.8691 13.4068 12.9202 13.3766 12.9585 13.4068C13.6218 13.9049 14.3615 14.0465 15.0248 14.0465C15.6117 14.0465 15.8157 13.6553 15.8157 13.3234C15.8157 12.9309 15.6739 12.7044 14.7554 12.2668C13.4416 11.6328 12.8946 11.088 12.8946 9.98623C12.8946 8.76356 13.8114 7.75366 15.3167 7.75366C16.0947 7.75366 16.6432 7.7745 17.0005 8.01586C17.0641 8.07627 17.077 8.12152 17.077 8.21214V9.44981C17.077 9.54026 17.0259 9.58572 16.9622 9.54026C16.503 9.23853 15.8525 9.14241 15.1892 9.14241Z"
          fill="#4FC7EC"
        />
      </g>
      <defs>
        <clipPath id="clip0_3685_63598">
          <rect
            width="22"
            height="22"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
